import { StrictMode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { IntlProvider } from '@lingoda/i18n';
import { type History, Router, renderRoutes } from '@lingoda/router';
import { CssBaseline, Suspense } from '@lingoda/ui';
import { getDashLang } from '@lingoda/env';
import { DialogsContextProvider } from '@lingoda/teacher-dialogs';
import routes from '../routes';
import { TeacherSnackbarProvider } from './providers/TeacherSnackbarProvider';
import { MonolithGraphQLProvider } from './providers';
import { PageErrorBoundary } from './PageErrorBoundary';
import { ThemeProvider } from './ThemeProvider';

interface Props {
    history: History;
}

const Root = ({ history }: Props) => {
    return (
        <StrictMode>
            <MonolithGraphQLProvider>
                <IntlProvider locale={getDashLang()}>
                    <ThemeProvider>
                        <CssBaseline />
                        <TeacherSnackbarProvider>
                            <HelmetProvider>
                                <DialogsContextProvider>
                                    <PageErrorBoundary>
                                        <Router history={history}>
                                            <Suspense variant="linear">
                                                {renderRoutes(routes)}
                                            </Suspense>
                                        </Router>
                                    </PageErrorBoundary>
                                </DialogsContextProvider>
                            </HelmetProvider>
                        </TeacherSnackbarProvider>
                    </ThemeProvider>
                </IntlProvider>
            </MonolithGraphQLProvider>
        </StrictMode>
    );
};

export default Root;
